// extracted by mini-css-extract-plugin
export default {"page":"layout_page__9tEPT","content":"layout_content__8yNkj"};